import { createSlice } from "@reduxjs/toolkit";
import { customPublish } from "../services/publish.services";

const initialState = {
  published: [],
  publish: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const publishSlice = createSlice({
  name: "publish",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetPublish(state) {
      state.responseMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(customPublish.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(customPublish.fulfilled, (state, action) => {
        state.responseMessage = action.payload.message;
        state.loading = false;
      })
      .addCase(customPublish.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
export const { resetPublish, resetState, resetError } = publishSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default publishSlice.reducer;
